import App from '@/app/App';
import '@/app/styles/index.css';
import '@/shared/config/i18n/i18n';
import { initSentry } from '@/shared/lib/sentry/sentry';
import { NuqsAdapter } from 'nuqs/adapters/react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

initSentry();

const handleChunkError = () => {
  const refreshCount = parseInt(
    window.sessionStorage.getItem('vite-refresh-count') ?? '0',
  );

  if (refreshCount < 3) {
    // Allow up to 3 refreshes
    window.sessionStorage.setItem(
      'vite-refresh-count',
      (refreshCount + 1).toString(),
    );
    window.location.reload();
  } else {
    // If we've tried 3 times, clear the counter and show error
    window.sessionStorage.removeItem('vite-refresh-count');
    console.error('Failed to load application after multiple attempt1');
    // Show a user-friendly error message
  }
};

// Add this before app initialization
window.addEventListener('vite:preloadError', handleChunkError);

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <NuqsAdapter>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </NuqsAdapter>,
);
